import React from 'react'
import FeatureList from './FeatureList'

const LeftPanel = () => (
    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        {/* Background pattern */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 via-blue-600 to-purple-700"></div>
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        
        {/* Floating elements */}
        <div className="absolute top-20 left-20 w-20 h-20 bg-white bg-opacity-10 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-32 w-16 h-16 bg-white bg-opacity-5 rounded-full animate-bounce delay-150"></div>
        <div className="absolute bottom-32 left-32 w-24 h-24 bg-white bg-opacity-10 rounded-full animate-pulse delay-300"></div>
        
        <div className="relative z-10 flex flex-col justify-center p-12 text-white">
            <div className="max-w-md">
                <h1 className="text-5xl font-bold mb-6 leading-tight">
                    Portal Interno
                    <span className="block text-3xl font-light text-blue-200">ERP Vox</span>
                </h1>
                <p className="text-xl text-blue-100 mb-8 leading-relaxed">
                    Sistema de gestão empresarial para equipe interna. 
                    Acesse suas ferramentas de trabalho e relatórios.
                </p>
                
                <FeatureList />
            </div>
        </div>
    </div>
)

export default LeftPanel